import { client } from '@stores'
import { adminNeighborhoodSearch } from './queries'
import { IAdminSearchNeighborhood, IConnection } from '@api/types'
interface Payload {
  data: {
    viewer: {
      company: {
        search: {
          neighborhoods: IConnection<IAdminSearchNeighborhood>
        }
      }
    }
  }
}
export default async function adminNeighborhood({
  query,
  apId,
  after,
  location,
  unseated,
}: {
  query: string
  apId: string
  after?: string | null
  location?: boolean
  unseated?: boolean
}): Promise<IConnection<IAdminSearchNeighborhood>> {
  const variables = {
    query,
    unseated,
    assignmentPlanId: apId,
    location,
    fetchEmployeeBooking: false,
    after: after || undefined,
  }
  return client.gql.query({ query: adminNeighborhoodSearch, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            search: { neighborhoods },
          },
        },
      },
    }: Payload) => neighborhoods
  )
}
